<template>
    <vue-select
        ref="vueSelectSearchFee"
        placeholder="Fees (optional)"
        :options="feesOptionsFiltered"
        :clearable="true"
        :closeOnSelect="true"
        :clearSearchOnSelect="true"
        :filterable="false"
        :label="'name'"
        v-model="feeModel"
        @search="search"
        class="v-select-fee"
        multiple
        :disabled="disabled"
    >
        <template v-slot:no-options="{ search }">
            <div class="no-opt">
                <span v-if="search === ''">
                    Type to search
                </span>
                <span v-else-if="isPreLoading">
                    Loading...
                </span>
                <span v-else>
                    No result
                </span>
            </div>
        </template>
        <template v-slot:list-footer>
            <li ref="footerLoader" class="loader" v-if="hasNextPage">
                Loading...
            </li>
        </template>
    </vue-select>
</template>

<script>
import vueSelect from "vue-select";
import {
    filter,
    debounce,
    concat,
    uniqBy,
    differenceBy,
    forEach
} from "lodash";
import ItemServices from "@/services/items";

/**
 * @name VetSelectFee
 * @description this component implement search and auto pagination, the infinite scroll is not working during dev
 */
export default {
    components: {
        vueSelect
    },
    props: {
        itemId: {
            type: String
        },
        value: {
            default: () => [],
            type: Array
        },
        disabled: {
            type: Boolean,
            default: false
        },
        isDisplayPrice: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        feesOptionsFiltered() {
            return differenceBy(this.options, this.feeModel, "id");
        }
    },
    watch: {
        feeModel(value) {
            this.$emit("input", value);
        },
        value: {
            // trigger when parent update value
            handler(value) {
                this.feeModel = value;
            },
            immediate: true
        }
    },
    data() {
        return {
            query: "",
            hasNextPage: false,
            isPreLoading: false,
            loading: false,
            currentPage: 1,
            options: [],
            feeModel: []
        };
    },
    mounted() {
        this.fetching();
    },
    methods: {
        displayName(fee) {
            let label = fee.name;
            if (this.isDisplayPrice && fee.cost_plus_price) {
                label += ` (${fee.cost_plus_price.account_format})`;
            }
            return label;
        },
        updateDefaultFees(feesId) {
            if (feesId.length > 0) {
                this.feeModel = filter(this.options, opt => {
                    return feesId.find(fee => {
                        if (typeof fee === "object") {
                            return fee.id == opt.id;
                        } else {
                            return fee == opt.id;
                        }
                    });
                });
            } else {
                this.feeModel = [];
            }
        },
        search(value) {
            if (value.length >= 3) {
                this.hasNextPage = false;
                this.currentPage = 1;
                this.query = value;
                this.fetchOptions(value, this);
            }
        },
        fetchOptions: debounce(async (value, self) => {
            self.fetching();
        }, 350),
        async fetching() {
            let self = this;
            self.loading = true;
            if (self.currentPage == 1) {
                self.options = [];
                self.isPreLoading = true;
            }
            const params = {
                search: this.query,
                page: this.currentPage,
                perPage: this.PER_PAGE
            };
            let res;
            if (self.itemId) {
                res = await ItemServices.getFeesOptions(self.itemId, params);
            } else {
                res = await ItemServices.getFees(params);
            }

            if (this.isDisplayPrice) {
                forEach(res.data, fee => {
                    fee.name = this.displayName(fee);
                });
            }

            self.options = uniqBy(concat(self.options, res.data), "id");
            self.hasNextPage = res.current_page < res.last_page;
            self.currentPage++;
            if (self.hasNextPage) {
                const sleep = m => new Promise(r => setTimeout(r, m));
                await sleep(100);
                self.fetching();
            }

            self.loading = false;
            self.isPreLoading = false;
        }
    }
};
</script>

<style>
.no-opt {
    padding: 0 20px;
}
.loader {
    padding: 3px 20px;
    font-style: italic;
}
.v-select-fee .vs__dropdown-menu li {
    white-space: normal;
    word-wrap: break-word;
}
</style>
